<template>
  <button
    id="send_ny_vejkode"
    @click="onButtonClick"
    :disabled="disabled"
  >
    <div id="title">Send</div>
    <div id="subtitle">til GeoDK</div>
  </button>
</template>

<script>
export default {
  name: 'SendVejkodeButton',
  props: {
    onButtonClick: Function,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOrtho () {
      return this.map && this.map.getLayers().getArray()
        .find(function (l) {
          return l.get('title') === 'Ortho';
        })
        .get('visible');
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  height: 80px;
  width: 100%;
  background: $default-color-dark;
  cursor: pointer;
  border: none;
  text-decoration: none;
  color: white;
  padding: 0;
  margin-top: 10px;
  border-radius: 2px;
  box-shadow: 0 5px 20px 0 rgba(150,128,213,0.50);
}

#send_ny_vejkode:active {
  transform: translateY(-1px);
}

#send_ny_vejkode:disabled {
  transform: none;
  background:$default-color-light;
  cursor: default;
}

#title {
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 6px;
}

#subtitle {
  font-size: 11px;
}
</style>
